import React from 'react';
import { Container } from 'react-bootstrap';
import '../styles/brand.css';

const DataCollectionPolicy = () => (
  <main className="policy-page">
    <Container>
      <section className="policy-card">
        <p className="policy-kicker">Access70 LMS</p>
        <h1>Data Collection Policy</h1>
        <p className="policy-updated">Last updated: 19 June 2026</p>

        <h2>1. Data We Collect</h2>
        <p>
          The platform may collect account details, contact information, demographic fields, learner documents, programme enrolment
          data, attendance records, assessment activity, submissions, resource usage, messages, support requests, audit logs, and
          compliance reporting fields.
        </p>

        <h2>2. Why We Collect Data</h2>
        <p>
          Data is collected to manage programmes, verify learner participation, support facilitators and assessors, provide learning
          resources, issue operational communications, prepare reports, and meet funder, SETA, BEE, audit, and internal governance
          requirements.
        </p>

        <h2>3. Documents and Uploads</h2>
        <p>
          Uploaded files may include identity documents, qualification evidence, learner submissions, attendance files, templates,
          resources, and supporting compliance documents. Access is limited by user role and system permissions.
        </p>

        <h2>4. System Activity</h2>
        <p>
          The platform may record login activity, page activity, upload events, status changes, review decisions, errors, and audit
          events to keep the service secure, traceable, and reliable.
        </p>

        <h2>5. Third-Party Services</h2>
        <p>
          The system may connect to services such as Firebase, email delivery providers, calendar or meeting tools, storage services,
          and reporting integrations where required for platform operation.
        </p>

        <h2>6. Retention</h2>
        <p>
          Records are retained for as long as required for programme delivery, legal obligations, audit evidence, contractual reporting,
          and legitimate operational needs.
        </p>
      </section>
    </Container>
  </main>
);

export default DataCollectionPolicy;
